/* eslint-disable max-len */
import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import PropTypes from 'prop-types';
import styled from 'styled-components';
// eslint-disable-next-line import/no-extraneous-dependencies
import Grid from '@mui/material/Grid';
import Typography from '@digital-hig/mui/dist/Typography';
import dateFormat from 'dateformat';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/no-extraneous-dependencies */
import Divider from '@mui/material/Divider';
import ProductIcons from '../components/productIcons';
// import DownloadableResources from '../components/downloadableResources';
import ListCTA from '../components/listCTA';
import StatusButton from './statusButton';
import {
  PAGETYPE_TUTORIAL, PAGETYPE_CURATED, PAGETYPE_COURSE, PAGETYPE_MODULE, PAGETYPE_COLLECTION,
} from './constants';
import StatusPill from './statusPill';

const Header = ({
  pageType, data, isLoading, headerRef, isCompleted, isStarted, showStatusLoader,
}) => {
  const tutorialUpdate = (lastUpdateTimeStamp) => {
    const updatedTimeStamp = new Date(lastUpdateTimeStamp);
    const tutorialUpdatedTimeStamp = dateFormat(updatedTimeStamp, 'mmmm d, yyyy', true);
    return tutorialUpdatedTimeStamp;
  };

  if (!isLoading) {
    return (
      <>
        <RootElement ref={headerRef}>
          <Grid className="header-container maxWidth">
            <Grid container className="eyebrow">
              <Grid xs={8}>
                <ProductIcons products={data?.meta?.products} />
              </Grid>
              <Grid xs={4}>
                {(pageType === PAGETYPE_COURSE || pageType === PAGETYPE_MODULE) && <StatusPill isComplete={isCompleted} isStarted={isStarted} positioned={false} showStatusLoader={showStatusLoader} />}
              </Grid>
            </Grid>

            <Grid container sx={{ paddingTop: '24px' }}>
              <Grid xs={12} md={10} lg={8}>
                <Typography component="h1" variant="headline-large">
                  {data?.title}
                </Typography>
                {pageType === PAGETYPE_COLLECTION
                  && (
                    <Typography variant="body-copy-small">
                      {data?.description}
                    </Typography>
                  )}
                {pageType === PAGETYPE_CURATED
                  && (
                    <Typography variant="body-copy-small">
                      {data?.shortDescription}
                    </Typography>
                  )}
                {(pageType === PAGETYPE_TUTORIAL || pageType === PAGETYPE_COURSE || pageType === PAGETYPE_MODULE) && (<Typography dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data?.shortDescription) }} />)}

                {(pageType === PAGETYPE_COLLECTION || pageType === PAGETYPE_COURSE || pageType === PAGETYPE_MODULE || pageType === PAGETYPE_TUTORIAL || pageType === PAGETYPE_CURATED)
              && (
                <Grid container sx={{ flexDirection: { xs: 'column', md: 'row' } }}>
                  <Grid xs={12} md={3} className="content-meta">
                    <Typography variant="button-label-dense">Type:</Typography>
                    <Typography variant="body-copy-small">
                      {pageType === PAGETYPE_COLLECTION && 'Collection'}
                      {pageType === PAGETYPE_COURSE && 'Course'}
                      {pageType === PAGETYPE_MODULE && 'Module'}
                      {pageType === PAGETYPE_TUTORIAL && 'Tutorial'}
                      {pageType === PAGETYPE_CURATED && 'Curated list'}
                    </Typography>
                  </Grid>
                  {(pageType === PAGETYPE_CURATED || pageType === PAGETYPE_COLLECTION)
                  && (
                    <Grid xs={12} md={3} className="content-meta">
                      <Typography variant="button-label-dense">Number of items:</Typography>
                      <Typography className="tutorials-count" color="ink-on-background-60" variant="body-copy-small">
                        {(pageType === PAGETYPE_CURATED && data?.tutorials) && `${data?.tutorials.length}`}
                        {(pageType === PAGETYPE_COLLECTION && data?.itemCount) && `${data.itemCount}`}
                      </Typography>
                    </Grid>
                  )}
                  {(pageType === PAGETYPE_COURSE || pageType === PAGETYPE_MODULE || pageType === PAGETYPE_TUTORIAL)
                    && data?.meta?.effort && (
                    <Grid xs={12} md={3} className="content-meta">
                      <Typography variant="button-label-dense">Length:</Typography>
                      <Typography variant="body-copy-small">
                        {data?.meta?.effort?.displayName ? data?.meta?.effort?.displayName : data?.meta?.effort}
                      </Typography>
                    </Grid>
                  )}
                  {(pageType === PAGETYPE_TUTORIAL || pageType === PAGETYPE_COURSE || pageType === PAGETYPE_MODULE) && data?.announcements?.lastUpdated && (
                    <Grid xs={12} md={3} className="content-meta">
                      <Typography variant="button-label-dense">Last updated:</Typography>
                      <Typography component="span" variant="body-copy-small">{tutorialUpdate(data.announcements.lastUpdated)}</Typography>
                    </Grid>
                  )}
                </Grid>
              )}
                {/* {pageType === PAGETYPE_COURSE && data?.meta?.type && (
                    <Grid item>
                      <Typography className="tutorial-update" variant="short-copy-small">
                        <span>Course type:</span>
                        {' '}
                        <Typography component="span" color="ink-on-background-60" variant="short-copy-small">{data.meta.type}</Typography>
                      </Typography>
                    </Grid>
                  )}
                  {pageType === PAGETYPE_MODULE && data?.meta?.type && (
                    <Grid item>
                      <Typography className="tutorial-update" variant="short-copy-small">
                        <span>Module type:</span>
                        {' '}
                        <Typography component="span" color="ink-on-background-60" variant="short-copy-small">{data.meta.type}</Typography>
                      </Typography>
                    </Grid>
                  )} */}

              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12}>
                <Divider flexItem sx={{ marginTop: '47px', marginBottom: '33px' }} />
                {pageType === PAGETYPE_COURSE && (
                  <Grid className="actions">
                    <StatusButton hasCompleted={isCompleted} hasStarted={isStarted} courseData={data} />
                    <ListCTA data={data} isCourse analyticsArea="courseHeader" />
                  </Grid>
                )}
                {pageType === PAGETYPE_MODULE && (
                  <Grid className="actions">
                    <StatusButton hasCompleted={isCompleted} hasStarted={isStarted} moduleData={data} />
                    <ListCTA data={data} analyticsArea="moduleHeader" />
                  </Grid>
                )}
                {(pageType === PAGETYPE_COLLECTION || pageType === PAGETYPE_CURATED || pageType === PAGETYPE_TUTORIAL) && (
                  <Grid className="actions">
                    <ListCTA data={data} isCollection={pageType === PAGETYPE_COLLECTION} isCourse={pageType === PAGETYPE_CURATED} analyticsArea={`${pageType?.toLowerCase()}Header`} />
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </RootElement>
      </>
    );
  }
  return (
    <LoaderRootElement>
      <Skeleton width={30} height={30} />
      <Skeleton width={30} height={30} />
      <br />
      <Skeleton width={100} height={20} />
      <br />
      <Skeleton width={300} height={30} />
      <Skeleton width={200} height={30} />
      <br />
      <Skeleton className="text-lines" count={5} width={600} height={10} />
      <Skeleton className="text-lines" count={1} width={300} height={10} />
      <br />
      <br />
    </LoaderRootElement>
  );
};

const RootElement = styled.div`
     background-color: #f9f9f9;
    .header-container {
      margin: 0 auto;
      padding-top: 63px;
      padding-bottom: 38px;
      box-sizing: content-box;

      [class^="statusPill__"]{
        margin-left: auto;
        position: relative;
        top: 6px;
      }
      .eyebrow {
        margin-bottom: 12px;
        margin-top: 24px;
      }
    }
    .MuiGrid-root.MuiGrid-container {
      padding-left: 0;
      padding-right: 0;
    }
    .loader {
      max-width: 1220px;
      margin: 0 auto;
    }
    .loader.show{
      display: block;
    }
    .loader.hide{
      display: none;
    }

    h1 {
      margin: 4px 0 8px 0;
    }
    h1 + p {
      font-size: 16px;
      margin-bottom: 24px;
    }
    .tutorial-update span:first-child {
      font-weight: bold;
    }
    .content-meta {
      flex: 0 1 auto;
      text-wrap: nowrap;
      padding-right: 24px;
      padding-top: 24px;
    }
    .react-loading-skeleton {
      margin: 0 10px 10px 0;
    }
    .text-lines {
      display: block;
      margin: 5px 0 0 0;
    }
    .actions {
      display: flex;
      align-items: center;
      gap: 10px;
      
      [class^="listCTA"] > span {
        margin-right: 2em;
      }
    }
`;
const LoaderRootElement = styled.div`
    width: 1440px;
    margin: 94px auto;
    .react-loading-skeleton {
      margin-right: 15px;
      margin-bottom: 8px;
    }
`;

Header.propTypes = {
  data: PropTypes.shape({
    meta: PropTypes.shape({
      products: PropTypes.arrayOf(PropTypes.shape({})),
      effort: PropTypes.shape({ displayName: PropTypes.string }),
      type: PropTypes.string,
    }),
    media: PropTypes.shape({
      banner: PropTypes.string,
    }),
    id: PropTypes.string,
    title: PropTypes.string,
    shortDescription: PropTypes.string,
    description: PropTypes.string,
    tutorials: PropTypes.arrayOf(PropTypes.shape({})),
    educatorResources: PropTypes.shape({ content: PropTypes.arrayOf() }),
    announcements: PropTypes.shape({ lastUpdated: PropTypes.string }),
    dataSets: PropTypes.arrayOf(PropTypes.string),
    itemCount: PropTypes.number,
    rootContent: PropTypes.arrayOf(),
  }),
  pageType: PropTypes.string,
  isLoading: PropTypes.bool,
  curatedData: PropTypes.shape({}),
  headerRef: PropTypes.shape({}),
  isCompleted: PropTypes.string.isRequired,
  isStarted: PropTypes.string.isRequired,
  showStatusLoader: PropTypes.bool,
};

Header.defaultProps = {
  data: {},
  pageType: '',
  isLoading: false,
  curatedData: null,
  headerRef: null,
  showStatusLoader: false,
};

export default React.memo(Header);
